import axios from "axios";

export const GET_LIST_KEGIATAN = "GET_LIST_KEGIATAN";
export const GET_ID_KEGIATAN = "GET_ID_KEGIATAN";

const linkapi = "https://server-mpustaka.herokuapp.com/";
// const linklocal = "http://localhost:3006/";

export const getListKegiatan = () => {
    return (dispatch) => {
        //loading
        dispatch({
            type: GET_LIST_KEGIATAN,
            payload: {
                loading: true,
                data: false,
                errorMessage: false,
            },
        });
        //get API end-point
        axios
            .get(linkapi + `kegiatan?_sort=createAt&_order=desc`)
            .then((response) => {
                dispatch({
                    type: GET_LIST_KEGIATAN,
                    payload: {
                        loading: false,
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_LIST_KEGIATAN,
                    payload: {
                        loading: false,
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getIdKegiatan = (data) => {
    return (dispatch) => {
        //loading
        dispatch({
            type: GET_ID_KEGIATAN,
            payload: {
                loading: true,
                data: data,
                errorMessage: false,
            },
        });
    };
};
